<template>
    <div>
        <!-- <div class="no-display">
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar dense class="toolbar no-display" flat>
                <v-toolbar-title>Employee Monthly Attendance</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-row justify="center" dense>
                <v-radio-group v-model="radios" mandatory row class="ma-2 no-display">
                    <v-radio label="Add manually attendance" value="manually_att" color="#0f2027"></v-radio>
                    <v-radio label="Import Monthly attendance" value="import_att" color="#0f2027"></v-radio>
                </v-radio-group>
            </v-row>
            <!-- <center><strong>Import Monthly attendance</strong></center> -->
            <v-row dense v-if="radios == 'manually_att'" justify="center" class="no-display">
                <v-col cols="12" md="4" class="pt-4">
                    <v-autocomplete rounded outlined dense v-model="sal_mon_id" :items="sal_month_list"
                        item-text="sal_mon" return-object label="Select Month" />
                </v-col>
                <v-col cols="12" md="4" class="pt-4">
                    <v-autocomplete rounded outlined dense v-model="empid" :items="employee_list"
                        item-text="employee_code" item-value="employee_id" label="Select Employee" />
                </v-col>
                <v-col cols="12" md="2" class="pt-2">
                    <v-btn v-if="sal_mon_id" @click="getEmpMonthlyAttendance();show=true" class="button">Fetch</v-btn>
                </v-col>
            </v-row>
            <v-row dense justify="center" v-if="show && radios == 'manually_att'">
                <v-col cols="12" sm="12" md="12">
                    <v-row dense justify="center">
                        <v-col cols="12" sm="4" md="4" class="no-display">
                            <v-text-field class="pt-3" type="number" label="Working Days" rounded outlined dense
                                v-model="sal_mon_id.number_of_days"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="no-display">
                            <v-btn class="button" @click="set_working_days()">Set Working days</v-btn>
                        </v-col>
                    </v-row>
                </v-col>
                <v-row dense>
                    <v-col cols="12" sm="2" md="2">
                        <v-btn class="ma-2 no-display" rounded color="success" outlined
                            @click="fnExcelReport('my-table-id', 'EmployeeMonthlyAttendance')" :loading="loader"><v-icon
                                color="success">mdi-export</v-icon>Export</v-btn>
                    </v-col>
                    <v-col cols="12" sm="8" md="8" align="center" class="no-display" style="align-content: center;">
                        <span style="opacity: 0.5;">Note: If working days set please click save/update button to save
                        employee attendance </span>
                    </v-col>
                    <v-col cols="12" sm="2" md="2" align="right">
                        <v-btn class="ma-2 no-display" tile outlined color="warning" @click="print()"> <v-icon
                                left>mdi-printer</v-icon> Print <v-icon right></v-icon> </v-btn>
                    </v-col>
                </v-row>
                <v-col cols="12" sm="12" md="12">
                    <div id="my-table-id">
                        <v-data-table v-if="empid!=null" :headers="headers" dense :items="bookList1"  @current-items="getFiltered"
                            class="elevation-1 mytable">
                            <template v-slot:top>
                                <v-toolbar class="toolbar" flat dense>
                                    <v-toolbar-title>
                                        <strong>
                                            Mark Employee Monthly Attendance
                                        </strong>
                                    </v-toolbar-title>
                                </v-toolbar>
                                <br />
                                <v-row dense justify="center">
                                    <tr class="t-row">
                                    <div>
                                        <th>
                                        <v-row>
                                            <span v-for="header in headers" :key="header.text">
                                            <span v-if="filters.hasOwnProperty(header.value)">
                                                <v-autocomplete class="mr-2 pb-5 pt-2" flat hide-details small rounded dense outlined
                                                color="#0F2027" :label="header.text" multiple clearable :items="columnValueList(header.value)"
                                                v-model="filters[header.value]"></v-autocomplete>
                                            </span>
                                            </span>
                                        </v-row>
                                        </th>
                                    </div>
                                    </tr>
                                </v-row>
                            </template>
                            <template v-slot:item.working_days="{ item }">
                                <span v-if="item.employeeSalaryMaster == null">
                                    <span class="textcolor">
                                        <strong>
                                            <center>{{item.working_days}}</center>
                                        </strong>
                                    </span>
                                </span>
                                <span v-else>
                                    <v-text-field class="pt-3" type="number" label="Enter Working Days" rounded outlined
                                        dense v-model="item.working_days"></v-text-field>
                                </span>
                            </template>
                            <template v-slot:item.action="{ item }">
                                <span v-if="item.employeeSalaryMaster == null">
                                    <span class="textcolor">
                                        <strong>
                                            <center>NA</center>
                                        </strong>
                                    </span>
                                </span>
                                <span v-else>
                                    <v-btn small @click="saveEmpMonthlyAttendanceIndividual(item);"
                                        :loading="load_individual" class="button">Save / Update</v-btn>
                                </span>
                            </template>
                        </v-data-table>
                        <v-data-table v-else :headers="headers" dense :items="bookList1"  @current-items="getFiltered"
                            class="elevation-1 mytable" :items-per-page="-1">
                            <template v-slot:top>
                                <v-toolbar class="toolbar" flat dense>
                                    <v-toolbar-title>
                                        <strong>
                                            Mark Employee Monthly Attendance
                                        </strong>
                                    </v-toolbar-title>
                                </v-toolbar>
                                <br />
                                <v-row dense justify="center">
                                    <v-col cols="12" sm="1" md="1"></v-col>
                                    <tr class="t-row">
                                    <div>
                                        <th>
                                        <v-row>
                                            <span v-for="header in headers" :key="header.text">
                                            <span v-if="filters.hasOwnProperty(header.value)">
                                                <v-autocomplete class="mr-2 pb-5 pt-2" flat hide-details small rounded dense outlined
                                                color="#0F2027" :label="header.text" multiple clearable :items="columnValueList(header.value)"
                                                v-model="filters[header.value]"></v-autocomplete>
                                            </span>
                                            </span>
                                        </v-row>
                                        </th>
                                    </div>
                                    </tr>
                                </v-row>
                            </template>
                            <template v-slot:item.working_days="{ item }">
                                <span v-if="item.employeeSalaryMaster == null">
                                    <span class="textcolor">
                                        <strong>
                                            <center>{{item.working_days}}</center>
                                        </strong>
                                    </span>
                                </span>
                                <span v-else>
                                    <v-text-field class="pt-3" type="number" label="Enter Working Days" rounded outlined
                                        dense v-model="item.working_days"></v-text-field>
                                </span>
                            </template>
                            <template v-slot:item.action="{ item }">
                                <span v-if="item.employeeSalaryMaster == null">
                                    <span class="textcolor">
                                        <strong>
                                            <center>NA</center>
                                        </strong>
                                    </span>
                                </span>
                                <span v-else>
                                    <v-btn small @click="saveEmpMonthlyAttendanceIndividual(item);"
                                        :loading="load_individual" class="button">Save / Update</v-btn>
                                </span>
                            </template>
                        </v-data-table>
                    </div>
                </v-col>
                <v-btn @click="saveEmpMonthlyAttendance();show=true" :loading="load" class="button no-display">Save /
                    Update</v-btn>
            </v-row>

            <v-row dense v-if="radios == 'import_att'" justify="center" class="no-display">
                <v-col cols="12" md="4" class="pt-4">
                    <v-autocomplete rounded outlined dense v-model="sal_mon_id" :items="sal_month_list"
                        item-text="sal_mon" return-object label="Select Month" />
                </v-col>
                <v-col cols="12" sm="4" md="4" class="pt-4">
                    <v-file-input placeholder="CSV of employee data" prepend-icon="mdi-file"
                        label="Employee Attendance Data" rounded dense flat outlined show-size
                        v-model="file"></v-file-input>
                </v-col>
                <v-col cols="12" sm="4" md="4" class="pt-4">
                    <a
                        href="https://eduplusschool.s3.ap-south-1.amazonaws.com/sample_csv_files/csv_files/Import_employee_monthly_attendance.csv">
                        <v-btn :loading="loading3" :disabled="loading3" color="blue-grey" outlined
                            class="ma-2 white--text downbtn button" @click="loader = 'loading3'">
                            Download import CSV format
                            <v-icon right dark>mdi-cloud-download</v-icon>
                        </v-btn>
                    </a>
                </v-col>
                <v-col cols="12" md="4" class="pt-2">
                    <v-btn v-if="sal_mon_id" @click="submitFile" class="button" :loading="output_load">Import Employee
                        Attendance</v-btn>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                    <template v-if="load == true">
                        <v-data-table v-if="failedlist != ''" :headers="headers1" :items="failedlist" sort-by
                            class="elevation-1 mytable" dense :search="search" :loading="output_load">
                            <template v-slot:top>
                                <v-toolbar flat dense class="toolbar">
                                    <v-toolbar-title>Failed Data</v-toolbar-title>
                                    <v-divider class="mx-4" inset vertical></v-divider>
                                    <v-spacer></v-spacer>
                                </v-toolbar>
                                <br />
                            </template>
                        </v-data-table>
                        <v-data-table v-if="statuslist != ''" :headers="headers2" :items="statuslist" sort-by
                            class="elevation-1 mytable" dense :search="search" :loading="output_load">
                            <template v-slot:top>
                                <v-toolbar flat dense class="toolbar">
                                    <v-toolbar-title>Success Data</v-toolbar-title>
                                    <v-divider class="mx-4" inset vertical></v-divider>
                                    <v-spacer></v-spacer>
                                </v-toolbar>
                                <br />
                            </template>
                        </v-data-table>
                    </template>
                </v-col>
            </v-row>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
        data() {
            return {
                emppersonname: "",
                extraBreadcrumbItems: [
                 

                ],
                breadcrumbClass: "breadcrumb-style1",
                empdesignation: null,
                emptypename: null,
                snackbar_msg: "",
                color: "",
                snackbar: false,
                search: "",
                load: false,
                load_individual: false,
                show: false,
                empid: null,
                sal_mon_id: null,
                sal_month_list: [],
                employee_list: [],
                radios: null,
                file: null,
                output_load: false,
                employee_month_attendace_list: [],
                table_fields: {
                    "Sr. No": "srno",
                    Employee: "employee_code",
                    "Working Days": "working_days",
                },
                 filters: {
                employee_code: [],
                emp_section: [],
            },
            filterArr: [],
                headers: [
                    {
                        text: "Sr. No.",
                        sortable: false,
                        value: "srno",
                    },
                    {
                        text: "Employee",
                        align: "center",
                        sortable: false,
                        value: "employee_code",
                    },
                    {
                        text: "Employee Section",
                        align: "center",
                        sortable: false,
                        value: "emp_section",
                    },
                    {
                        text: "Working Days",
                        align: "center",
                        sortable: false,
                        value: "working_days",
                        width: 400,
                    },
                    {
                        text: "Action",
                        align: "center",
                        sortable: false,
                        value: "action",
                        width: 400,
                    },
                ],
                headers2: [
                    { text: "Sr.NO", value: "serial_number" },
                    { text: "Login Id", value: "employeecode" },
                    { text: "Working Days", value: "workingdays" },
                    { text: "Reason", value: "reason" },
                ],
                headers1: [
                    { text: "Sr.NO", value: "serial_number" },
                    { text: "Login Id", value: "employeecode" },
                    { text: "Working Days", value: "workingdays" },
                    { text: "Reason", value: "reason" },
                ],
            };
        },
        computed: {
            bookList1() {
            return this.employee_month_attendace_list.filter((d) => {
                return Object.keys(this.filters).every((f) => {
                return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
                });
            });
            },
        },
        mounted() {
            axios
                .post("/Payroll/getSalaryMonthAndEmp")
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.employee_list = res.data.employee_list;
                        this.sal_month_list = res.data.sal_month_list;
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something Went Wrong");
                });
        },
        methods: {
            getFiltered(e) {
                this.filterArr = e;
            },
            columnValueList(val) {
                console.log("in col fin", val);
                return this.employee_month_attendace_list.map((d) => d[val]);
            },
            fnExcelReport(id, name) {
                let tab_text = `<table border='1px'>
                    <tr>
                    <th>Sr. No.</th>
                    <th>Employee</th>
                    <th>Working Days</th>
                    <th>Action</th>
                    
                    </tr>`;

                                this.employee_month_attendace_list.forEach((item, index) => {
                                    tab_text += `
                    <tr>
                    <td>${index + 1}</td>
                    <td>${item.employee_code || ""}</td>
                    <td>${item.working_days || ""}</td>
                    <td>${item.action || "NA"}</td>
                    </tr>`;
                });

                tab_text += "</table>";

                const blob = new Blob([tab_text], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                const filename = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    // For IE
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else {
                    // For modern browsers
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = filename;
                    a.click();
                    window.URL.revokeObjectURL(url);
                }
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            print() {
                this.$store.state.drawer = false;
                let that = this;
                window.onafterprint = function () {
                    that.$store.state.drawer = true;
                };
                setTimeout(function () {
                    window.print();
                }, 100);
            },
            set_working_days() {
                for (var i = 0; i < this.employee_month_attendace_list.length; i++) {
                    if (this.employee_month_attendace_list[i].employeeSalaryMaster != null) {
                        if (this.employee_month_attendace_list[i].working_days == 0) {
                            this.employee_month_attendace_list[i].working_days = this.sal_mon_id.number_of_days;
                        }
                    }
                }
            },
            getEmpMonthlyAttendance() {
                this.employee_month_attendace_list = [];
                const data = {
                    emp_id: this.empid,
                    sal_mon_id: this.sal_mon_id.id,
                };
                axios
                    .post("/Payroll/getEmpMonthlyAttendance", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.employee_month_attendace_list = res.data.employee_month_attendace_list;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                    });
            },
            saveEmpMonthlyAttendanceIndividual(item) {
                if (item.working_days > this.sal_mon_id.number_of_days) {
                    this.showSnackbar("#b71c1c", "Days should less than or equal selected month days");
                    return;
                }
                this.load_individual = true;
                const data = {
                    employee_month_attendace_data: item,
                };
                axios
                    .post("/Payroll/saveEmpMonthlyAttendanceIndividual", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4caf50", "Saved successfully!!!");
                            this.getEmpMonthlyAttendance();
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("#b71c1c", "Salary Month Freezed");
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.load_individual = false;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                        this.load_individual = false;
                    });
            },
            saveEmpMonthlyAttendance() {
                for (var i = 0; i < this.employee_month_attendace_list.length; i++) {
                    if (this.sal_mon_id.number_of_days < this.employee_month_attendace_list[i].working_days) {
                        this.showSnackbar("#b71c1c", "Days should less than or equal selected month days");
                        return;
                    }
                }
                this.load = true;
                const data = {
                    employee_month_attendace_list: this.employee_month_attendace_list,
                };
                axios
                    .post("/Payroll/saveEmpMonthlyAttendance", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4caf50", "Saved successfully!!!");
                            this.getEmpMonthlyAttendance();
                            this.load = false;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                        this.load = false;
                    });
            },
            submitFile() {
                if (this.file == null) {
                    alert("Please select the file!");
                } else {
                    this.output_load = true;
                    let formData = new FormData();
                    formData.append("file", this.file);
                    formData.append("sal_mon_id", this.sal_mon_id.id);
                    axios
                        .post("Payroll/importemployeemonthlyattendance", formData, {
                            headers: {
                                "Content-Type": "multipart/form-data",
                            },
                        })
                        .then((res) => {
                            if (res.data.flag == "YES") {
                                this.statuslist = res.data.statuslist[0].statuslist;
                                this.failedlist = res.data.statuslist[0].failedlist;
                                this.load = true;
                                this.output_load = false
                                this.showSnackbar("#4caf50", "Imported Successfully !!");
                            } else if (res.data.flag == "NO") {
                                this.showSnackbar("#b71c1c", res.data.fmsg);
                                this.output_load = false
                            } else {
                                this.showSnackbar("#b71c1c", "Something went wrong!!!");
                                sessionStorage.setItem("error-trace", res.data.error_trace);
                                this.output_load = false
                            }
                        })
                        .catch((error) => {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            this.output_load = false
                        })
                        .finally(() => {
                            this.output_load = false;
                        });
                }
            },
        },
    };
</script>
<style scoped>
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    .textcolor {
        color: red !important;
    }

    @media print {
        header,
        footer,
        nav,
        date {
            display: none !important;
        }
        table,
        td,
        tr {
            break-inside: avoid-page;
        }

        /* img {
    width: 100% !important;
  } */
        .scroll {
            overflow-x: hidden;
        }
        body,
        tr,
        th,
        td,
        center {
            font-size: 14pt !important;
            font-weight: bold !important;
        }

        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"],
        #v-card {
            display: none !important;
        }
        v-card {
            border: none !important;
        }
        .trust-logo {
            width: 86%;
        }
        .schl-logo {
            width: 83%;
        }

        @page {
            size: A4;
            margin: 0px;
            /* padding: 0px; */
            /* size: 15.5in 15.5in; */
            size: 25in 19in;
        }

        .table-data {
            height: 100% !important;
            overflow-x: hidden;
            overflow-y: hidden !important ;
        }
        .box {
            /* height: 100% !important; */
            overflow-x: hidden;
            border: none !important;
        }
    }
</style>
<!-- abcd -->
